import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const podcasts = $$('.podcasts');

if (podcasts.length) {
  podcasts.forEach(podcast => {
    const slider = new Swiperslider($('.podcasts__item-wrapper', podcast), {
      container: podcast,
      sliderOptions: {
        spaceBetween: 30,
        breakpoints: {
          // when window width is >= 640px
          768: {
            spaceBetween: 80,
          },
        },
      },
    });
    slider.init();
  });
}
